import { createFileRoute } from '@tanstack/react-router';
import { PaymentsHub } from '@/components/company/payments/payments-hub';

export const Route = createFileRoute('/(app)/company/payments/vendor')({
	component: VendorPaymentsRoute,
});

function VendorPaymentsRoute() {
	return <PaymentsHub mode="vendor" />;
}
